// Canonical "renders for guests" route allowlist — the SINGLE source of truth
// shared by the bootShell load-gate AND the SPA route-change guard
// (workspace/app.js _authRouteGuard). Any path NOT matching this is a
// PROTECTED workspace page: an unauthenticated visit — whether a hard page
// load OR a client-side router navigation — is bounced to /login.
//
// SECURITY: keeping ONE regex here means the load-gate and the nav-guard can
// never drift. That invariant is load-bearing — before this, the gate only
// ran at hard page-load (bootShell getMe → /login), so a client-side
// `el.router('/')` (e.g. the old /login "X" close button) walked straight into
// the authed app with no credentials (platform#2278). The nav-guard closes
// that hole; this list is what both gates agree on.
//
// Members:
//   - auth chrome: login / signin / signup / signup-confirmation /
//     reset-password / forgot-password / verify-email, plus the OAuth +
//     magic-link callbacks (auth/callback, auth/magic-callback,
//     github-auth-callback)
//   - anonymous-by-design surfaces: meet-guest (waiting-room join form),
//     _session-bridge (cross-app token hop)
//   - public read surfaces: /user/:slug + /u/:slug (public profiles),
//     /marketplace[/…] (public catalogue), /feed[/…]
//   - demo gate: /demo — the demo.symbols.app email gate (isDemoHost), an
//     anonymous-by-design surface where unauthed is the expected state; without
//     it bootShell's load-gate rewrites /demo → /login and the gate never shows.
//   - invitation landings: /accept-invite, /accept-org-invite,
//     /accept-team-invite, /accept-workspace-invite, /waitlist-invite — the
//     server's emailed buildInviteUrl targets. They must render PRE-AUTH so the
//     accept page itself can bounce unauthed recipients to /login?next=<self>
//     with the ?token= intact (waitlist forwards to /signup?token=…). A gate
//     that rewrote them to bare /login is exactly the P0 invite dead-end
//     (2026-08-06).
// THE ONE public-path list: the boot gate (bootResolve) AND the shell's router
// guard / cold-boot bounce (workspace auth.js authRedirectTarget, through
// isGuestAllowedPath) read it. `s/<token>` is the public share-link viewer
// (PUBLIC-SHARE-LINKS-1): its token IS the credential.
export const GUEST_ROUTE_RE =
  /^\/(demo|login|signin|signup|signup-confirmation|reset-password|forgot-password|verify-email|auth\/magic-callback|auth\/callback|github-auth-callback|meet-guest|_session-bridge|accept-invite|accept-org-invite|accept-team-invite|accept-workspace-invite|waitlist-invite|user\/[^/]+|u\/[^/]+|s\/[^/?#]+)(\/|\?|#|$)|^\/(?:marketplace(?:\/(?:feed|installable-rail-demo|prompt-gallery))?|feed)\/?(?:[?#]|$)/

// True when `path` may render for an unauthenticated visitor.
export const isGuestAllowedPath = (path) =>
  GUEST_ROUTE_RE.test(typeof path === 'string' && path ? path : '/')
